export default "__VITE_ASSET__CTGBKXto__"